function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 
 * 
useage:

interface MyEventData {
  message: string;
}

const eventEmitter = new EventEmitter<MyEventData>();

// subscribe
const handler1: EventHandler<MyEventData> = (data) => {
  console.log(`Handler 1 received: ${data.message}`);
};

eventEmitter.on('customEvent', handler1);

// emit
eventEmitter.emit('customEvent', { message: 'Hello, Event Emitter!' });

// cancel
eventEmitter.off('customEvent', handler1);
 */
export var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    _defineProperty(this, "events", new Map());
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, handler) {
      if (!this.events.has(event)) {
        this.events.set(event, []);
      }
      this.events.get(event).push(handler);
    }
  }, {
    key: "off",
    value: function off(event, handler) {
      if (this.events.has(event)) {
        var handlers = this.events.get(event);
        var index = handlers.indexOf(handler);
        if (index !== -1) {
          handlers.splice(index, 1);
        }
        if (handlers.length === 0) {
          this.events.delete(event);
        }
      }
    }
  }, {
    key: "emit",
    value: function emit(event, data) {
      if (this.events.has(event)) {
        var handlers = this.events.get(event);
        handlers.forEach(function (handler) {
          return handler(data);
        });
      }
    }
  }]);
  return EventEmitter;
}();